import styled, { css } from "styled-components";

import buildColor from "../../_static/ColorPalette";

const RaceList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  ${(props) =>
    props.hasMoreButtonPresent
      ? css`
          & > li {
            border-bottom: 1px solid ${buildColor("blue", "100")};
          }
        `
      : css`
          & > li:not(:first-child) {
            border-top: 1px solid ${buildColor("blue", "100")};
          }
        `};
  ${(props) =>
    props.borderOnLastItem &&
    css`
      & > li:last-child {
        border-bottom: 1px solid ${buildColor("blue", "100")};
      }
    `}
`;

export default RaceList;
